import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { takeUntil, tap } from 'rxjs/operators';
import { DestroyableComponent } from '../../../../utils/destroyable.component';
import { OrderService } from '../../../../../providers/order/order.service';

interface DialogData {
  price: number;
  pickDate: Date;
  deliveryDate: Date;
}

@Component({
  selector: 'app-offer-discount',
  templateUrl: './offer-discount.component.html',
  styleUrls: ['./offer-discount.component.scss'],
})
export class OfferDiscountComponent extends DestroyableComponent implements OnInit {
  public message: string;
  public dataForm = this.buildDataForm();
  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<OfferDiscountComponent>,
    private orderService: OrderService,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
  ) {
    super();
  }

  get controls() {
    return this.dataForm.controls;
  }

  price: number;
  discount: number = 0;

  ngOnInit() {
    this.price = this.data.price;
    this.getControl('discount').valueChanges.pipe(
      takeUntil(this.onDestroy),
      tap(discount => this.getControl('priceWithDiscount')
        .setValue(+this.getPriceWithDiscount(discount), { emitEvent: false }))
    ).subscribe();

    this.getControl('priceWithDiscount').valueChanges.pipe(
      takeUntil(this.onDestroy),
      tap(priceWithDiscount => this.getControl('discount')
        .setValue(+this.getDiscountByNewPrice(priceWithDiscount), { emitEvent: false }))
    ).subscribe();
  }

  public getPriceWithDiscount(discount) {
    return this.orderService.formatPrice(this.price - this.price * (discount / 100));
  }

  public getDiscountByNewPrice(newPrice) {
    return this.orderService.formatPrice((1 - newPrice / this.price) * 100);
  }

  public getControl(key: string) {
    return this.dataForm.controls[key];
  }

  send() {
    if (this.dataForm.invalid) {
      return;
    }

    this.dialogRef.close(this.dataForm.value);
  }

  private buildDataForm() {
    return this.fb.group({
      discount: new FormControl(0, [Validators.required]),
      priceWithDiscount: new FormControl(this.orderService.formatPrice(this.data.price), [Validators.required]),
      deliveryDate: new FormControl(this.data.deliveryDate, [Validators.required]),
      pickDate: new FormControl(this.data.pickDate, [Validators.required]),
    });
  }
}
